import React, {useState} from 'react';
import {Button, Form, FormGroup, Input, InputGroup, Modal} from 'reactstrap';
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import {RotateCircleLoading} from "react-loadingg";
import LoadingOverlay from "react-loading-overlay";
import ClassApiService from "../../api/classes-api-service";
import businessApiService from "../../api/business-api-service";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

const SupportModal = (props) => {
    const [visible, setVisible] = useState(true);
    const [message, setMessage] = useState({title: props.prefilledTitle || "", message: props.prefilledMessage || ""});
    const [loading, setLoading] = useState(false);
    const [sendDisabled, setSendDisabled] = useState(false);
    const [messageSent, setMessageSent] = useState(false);

    const onDismiss = () => setVisible(false);

    const localize = () => {
        const loc = localeHelpers.currentLocale();
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    };

    localize();

    function sendMessageAction(event) {
        event.preventDefault();
        setLoading(true);

        businessApiService.sendSupportMessage({title: message.title, message: message.message})
            .then(res => {
                setLoading(false);
                setMessageSent(true);
            })
            .catch((e) => {
                setLoading(false);
                alert("Something went wrong. Please try again.")
            });
    }

    return (
        <Modal
            className="modal-dialog-centered modal-success"
            contentClassName="bg-gradient-success"
            isOpen={visible}
            toggle={props.toggleModal}
        >
            <LoadingOverlay
                active={loading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <div className="modal-header">
                    <h6 className="modal-title" id="modal-title-notification">
                        {/*Your attention is required*/}
                    </h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={props.toggleModal}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="py-3 text-center">
                        <img
                            alt="..."
                            width={64}
                            src={require("assets/img/brand/open-white-logo.png")}/>
                        {messageSent === false &&
                        <h4 className="mt-4 text-white"><small>{alertStrings.support_expl}</small></h4>
                        }
                        {messageSent === false ?
                            (<Form role="form">
                                <FormGroup className="mb-3">
                                    <InputGroup className="input-group-alternative">
                                        <Input placeholder={resourceStrings.title} type="text"
                                               id="message-input-title"
                                               defaultValue={message.title}
                                               onChange={handleMessageInputChange}/>
                                    </InputGroup>
                                </FormGroup>
                                <FormGroup>
                                    <InputGroup className="input-group-alternative">
                                        <Input placeholder={commonStrings.message}
                                               type="textarea" rows="5"
                                               id="message-input-text"
                                               defaultValue={message.message}
                                               onChange={handleMessageInputChange}/>
                                    </InputGroup>
                                </FormGroup>
                            </Form>) :
                            (<div className="mt-4">
                                <small className="text-white">{alertStrings.message_sent_success}</small>
                            </div>)
                        }
                    </div>
                </div>
                {messageSent === false &&
                <div className="modal-footer">
                    <Button
                        className="my-2"
                        color="secondary"
                        disabled={sendDisabled}
                        type="button"
                        onClick={e => sendMessageAction(e)}
                    >
                        {commonStrings.send}
                    </Button>
                </div>
                }
            </LoadingOverlay>
        </Modal>
    );

    function handleMessageInputChange(event) {
        let newValue = event.target.value;
        let targetId = event.target.id;

        let curMessage = message;

        switch (targetId) {
            case "message-input-title":
                curMessage.title = newValue;
                break;
            case "message-input-text":
                curMessage.message = newValue;
                break;
            default:
                return
        }

        setMessage(curMessage);
        setSendDisabled(curMessage.message < 10);
    }
};

export default SupportModal;